export const FEATURE_IMAGE = "FEATURE_IMAGE";

const initialState = {
  file: {}
};

export default function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FEATURE_IMAGE:
      return payload;

    default:
      return state;
  }
}

export function storeFeatureImage(payload) {
  return {
    type: FEATURE_IMAGE,
    payload
  };
}
